export interface RequestState<T = unknown> {
  loading: boolean;
  error?: Error | null;
  data?: T;
}
